module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-15-6e354fd06ec4a934a576a44c80e7ba4a.png";